import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Checkbox, FormControlLabel, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import AddIcon from '@material-ui/icons/Add';
import {
  parseFloatInputOrEmpty,
  parseIntegerInputOrEmpty,
} from '../../../../../utils/forms/parseNumberInput';

const candleTypes = [
  {
    definition: 'BREAK_HIGH',
    display: '2u',
    label: 'break high 2u',
    gridSize: 4,
  },
  {
    definition: 'BREAK_LOW',
    display: '2d',
    label: 'break low 2d',
    gridSize: 4,
  },
  {
    definition: 'BREAK_CANDLE',
    display: '2',
    label: 'break candle 2',
    gridSize: 4,
  },
  {
    definition: 'INSIDE_CANDLE',
    display: '1',
    label: 'inside candle 1',
    gridSize: 4,
  },
  {
    definition: 'FAIL_TO_BREAK_HIGH',
    display: 'fbh',
    label: 'fail break high (fbh)',
    gridSize: 4,
  },
  {
    definition: 'FAIL_TO_BREAK_LOW',
    display: 'fbl',
    label: 'fail break low (fbl)',
    gridSize: 4,
  },
  {
    definition: 'OUTSIDE_CANDLE',
    display: '3',
    label: 'outside candle 3',
    gridSize: 4,
  },
  {
    definition: 'OUTSIDE_CANDLE_UP',
    display: '3u',
    label: 'OUTSIDE CANDLE UP 3u',
    gridSize: 4,
  },
  {
    definition: 'OUTSIDE_CANDLE_DOWN',
    display: '3d',
    label: 'OUTSIDE CANDLE DOWN 3d',
    gridSize: 4,
  },
];

let rowCounter = 0;
let columnCounter = 0;

export default function CandlePatternSetup({
  setupFields,
  dispatchSetupDetails,
}) {
  const [candleDurationTxt, setCandleDurationTxt] = useState(
    setupFields.candleDuration
  );
  const [breakByOnTriggerTxt, setBreakByOnTriggerTxt] = useState(
    setupFields.breakByOnTrigger
  );
  //console.log(setupFields.candleDuration);
  useEffect(() => {
    //console.log("calling use effect")
    setCandleDurationTxt(setupFields.candleDuration);
  }, [setupFields.candleDuration]);

  useEffect(() => {
    //console.log("calling use effect")
    setBreakByOnTriggerTxt(setupFields.breakByOnTrigger);
  }, [setupFields.breakByOnTrigger]);
  // const [patternTxt, setPatternTxt] = useState(setupFields.candleDuration);
  const createFirstState = () => {
    //console.log("called create first state");
    let state = {};
    let pattern = setupFields.pattern;
    for (let row in pattern) {
      let r = pattern[row];
      state[rowCounter] = {};
      for (let column in r) {
        let candleSequence = r[column];
        let sequence = candleSequence.candleSequence;
        for (let i in candleTypes) {
          let type = candleTypes[i];
          if (sequence === type.definition) {
            state[rowCounter][columnCounter++] = type;
          }
        }
      }
      rowCounter++;
    }
    return state;
  };
  const [candlePatternObject, setCandlePatternObject] =
    useState(createFirstState);
  //console.log(candlePatternObject);

  //  console.log("rendering")
  //useEffect(() => {
  //  "rendering useEffect"
  //})
  useEffect(() => {
    //make sure first in list in fail fall, all following are restart
    //let pattern = "";
    let patternArray = [];
    /*console.log(candlePatternObject);*/
    let keys = Object.keys(candlePatternObject);
    for (let rowIndex in keys) {
      let rowKey = keys[rowIndex];
      let row = candlePatternObject[rowKey];
      let rowArr = [];
      let colCount = 0;
      for (let colIndex in row) {
        let candlePattern = row[colIndex];
        if (colCount === 0) {
          colCount++;
          let object = {
            terminateOnFail: false,
            restartOnFail: false,
            candleSequence: candlePattern.definition,
          };
          rowArr.push(object);
        } else {
          let object = {
            terminateOnFail: false,
            restartOnFail: true,
            candleSequence: candlePattern.definition,
          };
          rowArr.push(object);
        }
      }
      if (rowArr.length > 0) {
        //console.log(rowArr);
        patternArray.push(rowArr);
      }
    }
    //setPatternTxt(pattern);
    dispatchSetupDetails({ pattern: patternArray });
  }, [candlePatternObject]);

  useEffect(() => {
    let pattern = setupFields.pattern;
    let state = '';
    let p = '';
    for (let row in candlePatternObject) {
      for (let col in candlePatternObject[row]) {
        state += candlePatternObject[row][col].definition;
      }
    }
    for (let row in pattern) {
      for (let col in pattern[row]) {
        p += pattern[row][col].candleSequence;
      }
    }
    if (state !== p) {
      setCandlePatternObject(createFirstState());
    }
  }, [setupFields.pattern]);
  const CancelColumnButton = ({ row, col }) => {
    //  console.log(key)
    return (
      <IconButton
        size={'small'}
        style={{ width: 1, height: 1 }}
        onClick={(ev) => {
          //  console.log("removing")
          delete candlePatternObject[row][col];
          if (Object.keys(candlePatternObject[row]).length === 0) {
            delete candlePatternObject[row];
          }
          let deepCopy = {};
          Object.keys(candlePatternObject).forEach(
            (id) => (deepCopy[id] = candlePatternObject[id])
          );
          setCandlePatternObject(deepCopy);
        }}
      >
        <CancelIcon
          style={{
            color: 'red',
            backgroundColor: 'transparent',
            width: 15,
            height: 15,
          }}
        />
      </IconButton>
    );
  };

  const CancelRowButton = ({ row }) => {
    //  console.log(key)
    return (
      <IconButton
        //     size={"small"}
        style={{ width: 5, height: 5 }}
        onClick={(ev) => {
          //  console.log("removing")
          delete candlePatternObject[row];
          let deepCopy = {};
          Object.keys(candlePatternObject).forEach(
            (id) => (deepCopy[id] = candlePatternObject[id])
          );
          setCandlePatternObject(deepCopy);
        }}
      >
        <CancelIcon
          style={{
            color: 'blue',
            backgroundColor: 'transparent',
            width: 15,
            height: 15,
          }}
        />
      </IconButton>
    );
  };
  return (
    <>
      {candleTypes.map((value, index) => {
        return (
          <Grid item xs={value.gridSize} key={value.label}>
            <Button
              key={value.label}
              style={{
                fontSize: 8,
                backgroundColor: 'white',
                color: 'black',
                height: '100%',
                width: '100%',
              }}
              value={value}
              onClick={(ev) => {
                if (candlePatternObject[rowCounter] === undefined) {
                  candlePatternObject[rowCounter] = {};
                }
                //    console.log(value);
                candlePatternObject[rowCounter][columnCounter++] = value;
                //console.log(candlePatternObject);
                let deepCopy = {};
                Object.keys(candlePatternObject).forEach(
                  (key) => (deepCopy[key] = candlePatternObject[key])
                );
                //  console.log(deepCopy);
                setCandlePatternObject(deepCopy);
              }}
            >
              {value.label}
            </Button>
          </Grid>
        );
      })}
      <Grid item container xs={12}>
        <Grid item xs={2}>
          <TextField
            // variant="outlined"
            margin={'none'}
            id="outlined-basic"
            size={'small'}
            label={
              <Typography style={{ fontSize: 10 }}>candleDuration</Typography>
            }
            value={candleDurationTxt}
            onChange={(ev) => setCandleDurationTxt(ev.target.value)}
            onBlur={(ev) =>
              dispatchSetupDetails({
                candleDuration: parseIntegerInputOrEmpty(ev.target.value),
              })
            }
          />
          <TextField
            // variant="outlined"
            margin={'none'}
            id="outlined-basic"
            size={'small'}
            label={
              <Typography style={{ fontSize: 10 }}>
                break by on trigger
              </Typography>
            }
            value={breakByOnTriggerTxt}
            onChange={(ev) => setBreakByOnTriggerTxt(ev.target.value)}
            onBlur={(ev) =>
              dispatchSetupDetails({
                breakByOnTrigger: parseFloatInputOrEmpty(ev.target.value),
              })
            }
          />
          <FormControlLabel
            value="top"
            control={
              <Checkbox
                color="primary"
                checked={setupFields.evaluateLookBackOnStart}
                onChange={(ev) =>
                  dispatchSetupDetails({
                    evaluateLookBackOnStart: ev.target.checked,
                  })
                }
              />
            }
            label={
              <Typography style={{ fontSize: 10 }}>
                lookBack on start
              </Typography>
            }
            labelPlacement="start"
            size="small"
          />
          <FormControlLabel
            value="top"
            control={
              <Checkbox
                color="primary"
                checked={setupFields.evaluateLookBackOnRepeat}
                onChange={(ev) =>
                  dispatchSetupDetails({
                    evaluateLookBackOnRepeat: ev.target.checked,
                  })
                }
              />
            }
            label={
              <Typography style={{ fontSize: 10 }}>
                lookBack on repeat
              </Typography>
            }
            labelPlacement="start"
            size="small"
          />
        </Grid>
        <Grid item container xs={10}>
          {Object.keys(candlePatternObject).map((row) => {
            return (
              <Grid item container xs={12}>
                <Grid item xs={1}>
                  <CancelRowButton row={row} />
                </Grid>
                <Grid item container xs={11}>
                  {Object.keys(candlePatternObject[row]).map((col) => {
                    return (
                      <Grid item xs={1} key={row + '|' + col}>
                        <Typography style={{ fontSize: 11 }}>
                          {candlePatternObject[row][col].display}
                        </Typography>
                        <CancelColumnButton row={row} col={col} />
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={1}>
          <IconButton
            onClick={(ev) => {
              rowCounter++;
              candlePatternObject[rowCounter] = {};
              //    console.log(value);
              //console.log(candlePatternObject);
              let deepCopy = {};
              Object.keys(candlePatternObject).forEach(
                (key) => (deepCopy[key] = candlePatternObject[key])
              );
              //  console.log(deepCopy);
              setCandlePatternObject(deepCopy);
              /*  timeFrames[runningNumber++] = {candleDuration: 1, timeUnit: ""}
                              setTimeFrames(timeFrames);
                              dispatchSetUpDetails(Object.values(timeFrames));*/
            }}
            style={{ width: 1, height: 1 }}
            size="small"
          >
            <AddIcon style={{ color: 'green' }} />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}
